import { render, staticRenderFns } from "./RelatorioSinteticoAnaliticoFormacaoPorGre.vue?vue&type=template&id=94e0a1d2"
import script from "./RelatorioSinteticoAnaliticoFormacaoPorGre.vue?vue&type=script&lang=js"
export * from "./RelatorioSinteticoAnaliticoFormacaoPorGre.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports